module.exports = __webpack_public_path__ + "media/images/mobile/home/close_w-126916cdf9f9ac9101e8e21c5d94bbd0.png";